<template>
  <div>
    <div class="row mb-2">
      <div class="col-12" align="right">
        <button class="btn btn-add" @click="importarSetores()">Importar Setores do SIGAP</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'setorCrud'"
          crudName="Setores"
          newText="Novo Setor"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
          :key="reload"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      reload: 0,
      table: "specialtiesTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "title", "actions"],
      tableData: ["id", "title"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "title"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          title: "Titulo",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {
          company_id: function (h, row, index) {
            return row.company ? row.company.fantasy_name : "Sem Nome";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [""];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "setores",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
        description: "description",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    importarSetores: function () {
      const self = this;
      const api = self.$store.state.api + "setores-from-sigap/";

      self.$loading(true);
      axios
        .get(api)
        .then(() => {
          self.$loading(false);
          self.$message("Sucesso", "Setores importados com sucesso", "success");
          self.reload++;
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    }
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>